import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';
import TenantManager from './../../components/tenantManager';
import tenants from './tenants';
import messages from '../../text/messages';

import './users.css';

class UsersPage extends React.Component {
    render() {
        return (
            <div className="page">
                <TenantManager {...tenants} page={UsersPage.meta} />
            </div>
        );
    }
}

UsersPage.meta = {
    label: <FormattedMessage {...messages.users} />,
    icon: 'person',
    action: () => history.push('/users'),
    locations: ['/users']
};

export default UsersPage;



// WEBPACK FOOTER //
// ./src/pages/users/index.jsx